import { ConnectionEntity } from './abstract-connection.entity';

export abstract class ConnectionAggregateRoot<T> extends ConnectionEntity<T> {}
